import React from 'react';

import PropTypes from 'prop-types';

class Checkbox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isChecked: this.props.state
    };
  }

  handleChange(e) {
    const value = e.target.checked;

    this.setState({
      isChecked: value
    });

    if (this.props.onChange) {
      this.props.onChange(e, value);
    }
  }

  render() {
    return (
      <div className='custom-control custom-checkbox'>
        <input onChange={this.handleChange.bind(this)} type='checkbox' className='custom-control-input' disabled={this.props.disabled} id={this.props.id} checked={this.state.isChecked}/>
        <label className='custom-control-label' htmlFor={this.props.id}>{this.props.label}</label>
      </div>
    );
  }
}

Checkbox.propTypes = {
  id:       PropTypes.string.isRequired,
  state:    PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  label:    PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  onChange: PropTypes.func
};

export default Checkbox;
